import { render } from "./GovernmentTlds.vue?vue&type=template&id=426225ae&scoped=true"
import script from "./GovernmentTlds.vue?vue&type=script&lang=js"
export * from "./GovernmentTlds.vue?vue&type=script&lang=js"

import "./GovernmentTlds.vue?vue&type=style&index=0&id=426225ae&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426225ae"]])

export default __exports__